import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/icon.png'
import _imports_1 from './assets/appstore.png'
import _imports_2 from './assets/main-window.png'
import _imports_3 from './assets/messages.png'
import _imports_4 from './assets/dotfile.png'
import _imports_5 from './assets/hackernews.png'


const _withScopeId = n => (_pushScopeId("data-v-48c34b80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "toolbar-item" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("label", { class: "toolbar-item-name" }, "Ouroboros")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Docs", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Install", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "screen main" }
const _hoisted_10 = { class: "main-sidebar" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "app-name" }, "Ouroboros", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "app-desc" }, "A one stop workspace for developers", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-screen-shot-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "main-screen-shot",
    src: _imports_2
  })
], -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"screen section\" data-v-48c34b80><img class=\"feature-img\" src=\"" + _imports_3 + "\" data-v-48c34b80><div data-v-48c34b80><label class=\"feature-name\" data-v-48c34b80>Message Channel</label><label class=\"feature-desc\" data-v-48c34b80> Use your personal message channel to track event within your application, service, or system. </label></div></div><div class=\"screen section\" data-v-48c34b80><div data-v-48c34b80><label class=\"feature-name\" data-v-48c34b80>Dotfile Manager</label><label class=\"feature-desc\" data-v-48c34b80> Manage your dotfiles in one place. <br data-v-48c34b80>Keep your dotfiles sync and accessible across devices. </label></div><img class=\"feature-img\" src=\"" + _imports_4 + "\" data-v-48c34b80></div><div class=\"screen section\" data-v-48c34b80><img class=\"feature-img\" src=\"" + _imports_5 + "\" data-v-48c34b80><div data-v-48c34b80><label class=\"feature-name\" data-v-48c34b80>Hacker News Browser</label><label class=\"feature-desc\" data-v-48c34b80> Browse Hacker News in Ouroboros.<br data-v-48c34b80> Your reading records are kept and synced. </label></div></div><div class=\"footer\" data-v-48c34b80><a class=\"warning-label\" href=\"mailto:abctwiq@163.com\" data-v-48c34b80>Feedback &amp; Contact Us</a><label class=\"copy-right\" data-v-48c34b80>@2022</label></div>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showToolbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", {
            class: "toolbar-item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDocs && _ctx.onDocs(...args)))
          }, _hoisted_6),
          _createElementVNode("div", {
            class: "toolbar-item",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInstall && _ctx.onInstall(...args)))
          }, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("img", {
          class: "store",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInstall && _ctx.onInstall(...args))),
          src: _imports_1
        })
      ]),
      _hoisted_14
    ]),
    _hoisted_15
  ]))
}